import React from 'react'
import cn from 'classnames'

import { BrandType } from '@monorepo/interfaces'

type BrandItemPropsType = React.InputHTMLAttributes<HTMLInputElement> & {
  item: BrandType
  disabled?: boolean
}

export const BrandItem: React.FC<BrandItemPropsType> = ({ item, ...props }) => (
  <label
    className={cn('filter-list__item', {
      'filter-list__item--disabled': props.disabled,
    })}
  >
    <span className="input-check filter-list__input">
      <span className="input-check__body">
        <input className="input-check__input" type="checkbox" {...props} />
        <span className="input-check__box" />
        <span className="input-check__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="9px" height="7px">
            <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
          </svg>
        </span>
      </span>
    </span>
    <span className="filter-list__title">{item.name}</span>
    {/* <span className="filter-list__counter">{item.amount}</span> */}
  </label>
)
